import { render, staticRenderFns } from "./OrdersHistoryDetail.vue?vue&type=template&id=597d3a95&scoped=true&"
import script from "./OrdersHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./OrdersHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./OrdersHistoryDetail.vue?vue&type=style&index=0&id=597d3a95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "597d3a95",
  null
  
)

export default component.exports